import $ from 'jquery';

var $search = $('.search__sword');
$('.search__toggler').on('click', function(e) {

    if(!$search.hasClass('search__sword--visible')) {
        e.preventDefault();
        $search.addClass('search__sword--visible');
        $('#ke-search-searchbox-sword').focus();
    }

});

$(document).on('click', function(event) {
    if (!$(event.target).closest('#ke-search-searchbox-sword').length && !$(event.target).closest('.search__toggler').length) {
        $search.removeClass('search__sword--visible');
    }
});
